<template>
<div class="leaps-challenge-list">
<div class="container-fluid" v-if="getLeapsChallengeList.length > 0">
  <div class="table-responsive margin-Top-6Perc" >
    <table class="table table-striped">
      <thead>
        <tr>
          <th class="text-align-center font-size-15px border-right cursor-pointer">
            <span @click="selectedColumn('ChallengeTitle', 'asc', false)">Goal Title</span>
            <span class="row margin-right-0px margin-left-0px font-size-13px opacity-0Point2 cursor-pointer float-right" :class="{'opacity-1': currGoalTitleSortOrder === 'desc'}" @click="selectedColumn('ChallengeTitle', 'desc', true)">&#9660;</span>
            <span class="row margin-right-0px margin-left-0px font-size-13px opacity-0Point2 cursor-pointer float-right" :class="{'opacity-1': currGoalTitleSortOrder === 'asc'}" @click="selectedColumn('ChallengeTitle', 'asc', true)">&#9650;</span>
          </th>
          <th class="text-align-center font-size-15px border-right cursor-pointer">
            <span @click="selectedColumn('IsActive', 'asc', false)">Is Active</span>
            <span class="row margin-right-0px margin-left-0px font-size-13px opacity-0Point2 cursor-pointer float-right" :class="{'opacity-1': currGoalIsActiveSortOrder === 'desc'}" @click="selectedColumn('IsActive', 'desc', true)">&#9660;</span>
            <span class="row margin-right-0px margin-left-0px font-size-13px opacity-0Point2 cursor-pointer float-right" :class="{'opacity-1': currGoalIsActiveSortOrder === 'asc'}" @click="selectedColumn('IsActive', 'asc', true)">&#9650;</span>
          </th>
          <th class="text-align-center font-size-15px border-right">Attached Categories</th>
          <th class="text-align-center font-size-15px border-right">Created TS</th>
          <th class="text-align-center font-size-15px border-right">Updated TS</th>
          <th class="text-align-center font-size-15px">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="currLeapsChallengeObj in getLeapsChallengeList" :key="currLeapsChallengeObj.ChallengeLibraryId" :currLeapsChallengeObj="currLeapsChallengeObj">
          <td class="border-right text-align-center col-lg-3 col-md-3 border-right">{{currLeapsChallengeObj.ChallengeTitle}}</td>
          <td class="text-align-center col-lg-1 col-md-1 border-right">{{currLeapsChallengeObj.IsActive ? 'Yes' : 'No'}}</td> 
          <td class="border-right text-align-center col-lg-3 col-md-3 border-right"><span v-html="getAttachedCategories(currLeapsChallengeObj)"></span></td>
          <td class="text-align-center col-lg-1 col-md-1 border-right">{{formatAndShowDate(currLeapsChallengeObj.CreatedTS)}}</td>
          <td class="text-align-center col-lg-1 col-md-1 border-right">{{formatAndShowDate(currLeapsChallengeObj.UpdatedTS)}}</td>
          <td class="text-align-center col-lg-2 col-md-2">
            <a class="cursor-pointer" @click="performClickOperation($event,'edit', currLeapsChallengeObj)"> Edit </a>|
            <a class="cursor-pointer" @click="performClickOperation($event,'view', currLeapsChallengeObj)"> View </a>|
            <a class="cursor-pointer" @click="performClickOperation($event,'delete', currLeapsChallengeObj)"> Delete </a>
          </td>
        </tr>
      </tbody>
    </table>
    </div>
  </div>
  <update-leaps-challenge-overlay v-if="openEditOverlay" :currSelectedObj="currSelectedObj" @emittedValue="updateEmittedValue"></update-leaps-challenge-overlay>
  <view-leaps-challenge-overlay v-if="openViewOverlay" :currSelectedObj="currSelectedObj" @emittedValue="updateEmittedValue"></view-leaps-challenge-overlay>
  <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="deleteCurrentLeapsChallenge"></confirmation-alert>
  <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
  <loader></loader>
</div>
</template>
<script>
import { constants } from '@/utils/constants'
import { leapsChallengesService } from '@/server-util/leaps-challenges-service'
import UpdateLeapsChallengeOverlay from '@/components/leaps/challenges/UpdateLeapsChallengeOverlay'
import ViewLeapsChallengeOverlay from '@/components/leaps/challenges/ViewLeapsChallengeOverlay'
import AlertBox from '@/components/AlertOverlay'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import Loader from '@/components/dashboard/Loader'
import findIndex from 'lodash/findIndex'
import { leapsCategoryService } from '@/server-util/leaps-category-service'
import { find, forEach } from 'lodash'
export default {
  created: function () {
    this.getLeapsCategoryList()
  },
  props: ['leapsChallengesList'],
  computed: {
    getLeapsChallengeList: {
      get: function () {
        return this.leapsChallengesList
      }
    },
    getGlobalCategoryList: {
      get: function () {
        return this.$store.state.leapsCategoryList
      },
      set: function (newValue) {
        this.$store.state.leapsCategoryList = newValue
      }
    }
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      currSelectedObj: null,
      openEditOverlay: false,
      openViewOverlay: false,
      showConfirmationBox: false,
      prefixString: '',
      postString: '',
      currGoalTitleSortOrder: '',
      currGoalIsActiveSortOrder: ''
    }
  },
  name: 'leaps-challenge-list',
  methods: {
    selectedColumn: function (currSelectedColumn, orderBy = 'asc', clickedOnArrow) {
      var emitVal = false
      switch (currSelectedColumn) {
        case 'IsActive':
          if (clickedOnArrow) {
            if (this.currGoalIsActiveSortOrder === orderBy) {
              currSelectedColumn = 'IsActive'
              emitVal = false
            } else {
              this.currGoalIsActiveSortOrder = orderBy
              emitVal = true
            }
          } else {
            if (this.currGoalIsActiveSortOrder === '') {
              orderBy = 'asc'
            } else {
              orderBy = this.currGoalIsActiveSortOrder === 'asc' ? 'desc' : 'asc'
            }
            currSelectedColumn = 'IsActive'
            this.currGoalIsActiveSortOrder = orderBy
            emitVal = true
          }
          if (emitVal) {
            var objToEmit = {
              updateValues: true,
              SortType: orderBy,
              ColumnName: currSelectedColumn
            }
            this.$emit('sortBasedOnColumnName', objToEmit)
          }
          this.currGoalTitleSortOrder = ''
          break
        case 'ChallengeTitle':
          if (clickedOnArrow) {
            if (this.currGoalTitleSortOrder === orderBy) {
              currSelectedColumn = 'ChallengeTitle'
              emitVal = false
            } else {
              this.currGoalTitleSortOrder = orderBy
              emitVal = true
            }
          } else {
            if (this.currGoalTitleSortOrder === '') {
              orderBy = 'asc'
            } else {
              orderBy = this.currGoalTitleSortOrder === 'asc' ? 'desc' : 'asc'
            }
            currSelectedColumn = 'ChallengeTitle'
            this.currGoalTitleSortOrder = orderBy
            emitVal = true
          }
          if (emitVal) {
            objToEmit = {
              updateValues: true,
              SortType: orderBy,
              ColumnName: currSelectedColumn
            }
            this.$emit('sortBasedOnColumnName', objToEmit)
          }
          this.currGoalIsActiveSortOrder = ''
          break
      }
    },
    bindChallengeCategories: function (challengeCategories) {
      var strToShow = ''
      var counter = 1
      forEach(challengeCategories, (categoryId) => {
        const foundObj = find(this.getGlobalCategoryList, (obj) => {
          return categoryId === obj.CategoryId
        })
        if (foundObj !== undefined && foundObj !== 'undefined' && foundObj !== null && foundObj !== 'null' && foundObj !== '') {
          strToShow += counter + '. ' + foundObj.CategoryTitle + '<br/>'
          counter++
        }
      })
      return strToShow
    },
    getAttachedCategories: function (currSelectedObj) {
      return (currSelectedObj.ChallengeCategories !== undefined && currSelectedObj.ChallengeCategories !== 'undefined' && currSelectedObj.ChallengeCategories !== null && currSelectedObj.ChallengeCategories !== 'null' && currSelectedObj.ChallengeCategories !== '' && currSelectedObj.ChallengeCategories.trim().length !== 0) ? this.bindChallengeCategories(JSON.parse(currSelectedObj.ChallengeCategories)) : 'Not Found'
    },
    getLeapsCategoryList: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
      ) {
        if (storeObj.state.leapsCategoryList.length === 0) {
          this.$store.state.isLoading = true
        }
        leapsCategoryService
          .getLeapsCategoryList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.leapsCategoryList = responseObj.data
              this.$store.state.isLoading = false
            } else {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING LEAPS CATEGORY LIST'
        )
      }
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button confirmation overlay
      this.showConfirmationBox = value
      this.currSelectedObj = null
    },
    updateEmittedValue (recievedObj) {
      this.openEditOverlay = !recievedObj.closeOverlay
      this.openViewOverlay = !recievedObj.closeOverlay
      this.$store.state.isOverlayVisible = false
      var objToEmit = {
        updateValues: false,
        SortType: '',
        ColumnName: ''
      }
      this.$emit('sortBasedOnColumnName', objToEmit)
    },
    performClickOperation: function (event, operationName, selectedObj) {
      this.currSelectedObj = selectedObj
      switch (operationName) {
        case 'edit':
          this.openEditOverlay = true
          this.$store.state.isOverlayVisible = true
          break
        case 'view':
          this.openViewOverlay = true
          this.$store.state.isOverlayVisible = true
          break
        case 'delete':
          this.showConfirmationBox = true
          this.prefixString = 'Are you sure you want to delete '
          this.postString = '\'' + this.currSelectedObj.ChallengeTitle + '\' goal?'
          break
      }
    },
    formatAndShowDate: function (date) {
      var dateToPass = date
      if (dateToPass.indexOf('Z') === -1) {
        dateToPass += 'Z'
      }
      return dmAdminUtils.covertUtcToEst(dateToPass)
    },
    deleteCurrentLeapsChallenge (value) {
      this.showConfirmationBox = false
      if (value) {
        var storeObj = this.$store
        if (
          this.currSelectedObj.ChallengeLibraryId !== undefined &&
          this.currSelectedObj.ChallengeLibraryId !== null
        ) {
          this.$store.state.isLoading = true
          leapsChallengesService
            .deleteLeapsChallenge(
              storeObj.state.access_token,
              this.currSelectedObj.ChallengeLibraryId
            )
            .then(
              responseObj => {
                if (responseObj.status >= 200 && responseObj.status < 300) {
                  this.checkAndDeleteFromMasterLeapChallengeList()
                  this.$store.state.isLoading = false
                  var objToEmit = {
                    updateValues: false,
                    SortType: '',
                    ColumnName: ''
                  }
                  this.$emit('sortBasedOnColumnName', objToEmit)
                } else {
                  this.showAlertDialog = true
                  this.errorMsg =
                    'Oops! Something went wrong. Please try again.'
                  this.$store.state.isLoading = false
                }
              },
              errorObj => {
                this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg = errorObj.response.data.statusText
              }
            )
        } else {
          console.log(
            'ChallengeLibraryId is NULL hence declined DELETE LEAP CHALLENGE Operation'
          )
        }
      }
    },
    checkAndDeleteFromMasterLeapChallengeList: function () {
      const foundIndex = findIndex(this.$store.state.leapsChallengesList, (obj) => {
        return obj.ChallengeLibraryId === this.currSelectedObj.ChallengeLibraryId
      })
      if (foundIndex > -1) {
        this.$store.state.leapsChallengesList.splice(foundIndex, 1)
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader,
    'update-leaps-challenge-overlay': UpdateLeapsChallengeOverlay,
    'view-leaps-challenge-overlay': ViewLeapsChallengeOverlay,
    'confirmation-alert': ConfirmationOverlay
  }
}
</script>
<style scoped>
.margin-left-0px {
  margin-left: 0px !important;
}
.margin-right-0px {
  margin-right: 0px !important;
}
.font-size-13px {
  font-size: 13px;
}
.float-right {
  float: right;
}
.opacity-1 {
  opacity: 1 !important;
}
.opacity-0Point2 {
  opacity: 0.2;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.text-align-left {
  text-align: left;
}
.margin-Top-1Perc {
  margin-top: 1%;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-Top-3Perc {
  margin-top: 3%;
}
.margin-Top-6Perc {
  margin-top: 6%;
}
.margin-left-1Perc {
  margin-left: 1%;
}
.margin-left-2Perc {
  margin-left: 2%;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.overflow-x-hidden {
  overflow-x: hidden !important;
}
.leaps-challenge-list {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-left: inherit;
  padding-right: inherit;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.border-right {
  border-right: 1px solid #aaa !important;
}
.text-align-center {
  text-align: center !important;
}
.font-size-15px {
  font-size: 15px !important;
}
a:link {
  color: #2c3e50;
}
a:visited {
  color: #2c3e50;
}
a:hover {
  color: #2c3e50;
}
a:active {
  color: #2c3e50;
}
.btn-text-color {
  color: #2c3e50;
}
.cursor-pointer {
  cursor: pointer;
}
.text-decoration-underline {
  text-decoration: underline;
}
.table>thead>tr>th {
    vertical-align: bottom;
    border-bottom: 0px solid #aaaaaa;
}
.text-align-center{
  text-align: center !important;
}
a:link {
  color: #2c3e50;
}
a:visited {
  color: #2c3e50;
}
a:hover {
  color: #2c3e50;
}
a:active {
  color: #2c3e50;
}
.btn-text-color {
  color: #2c3e50;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/leaps/challenges/LeapsChallengeList.vue